export default __webpack_public_path__ + "static/media/184.5c13c718.gif";